import { http } from '../utils/http'

const searchAction = (params,page,size) => {
  const url = `/api/v1/roles/page?pageNo=${page-1}&pageSize=${size}`
  return http.post(url, params)
};
const addAction = (params) => {
  const url = '/api/v1/roles/add'
  return http.post(url, params)
};
const getAction = (id) => {
  const url = `/api/v1/roles/${id}/get`
  return http.post(url)
};
const editAction = (params,id) => {
  const url = `/api/v1/roles/${id}/update`
  return http.post(url, params)
};
const getOwnedPermissionAction = (id) => {
  const url = `/api/v1/roles/${id}/permission`
  return http.post(url)
};
const addPermissionAction = (params, id) => {
  const url = `/api/v1/roles/${id}/permission/bind`
  return http.post(url, params)
};
const deleteAction = (id) => {
  const url = `/api/v1/roles/${id}/delete`
  return http.post(url)
};
export default {
  searchAction,
  addAction,
  getAction,
  editAction,
  getOwnedPermissionAction,
  addPermissionAction,
  deleteAction
}
